import $ from "jquery";

export default class TabSwitcher {
  public init(initialPlatform: string | undefined) {
    if (initialPlatform) {
      this.toggleTab(initialPlatform);
    } else {
      const afterPath = window.location.hash.split("?")[0];
      if (afterPath && afterPath !== "") {
        const posAnchor = afterPath.indexOf("#");
        if (posAnchor != -1) {
          if (!this.toggleTab(afterPath.substr(posAnchor))) {
            this.toggleTab("#download30");
          }
        }
      } else {
        this.toggleTab("#download30");
      }
    }
    window.onhashchange = () => {
      this.toggleTab(location.hash);
    };
    $('[role="tab"]').on("click", function() {
      const newHref = this.getAttribute("href");
      if (window.location.href !== newHref) {
        window.location.href = newHref;
      }
    });

  }

  public toggleTab(os: string): boolean {
    const tabId = os.startsWith("#") ? os.substring(1) : os;
    const tab = $(`[href='#${tabId}']`);
    tab.tab("show");
    return tab.length > 0;
  }

}
